import { formatEatDate, formatEatDateTime } from '@wodi/domain';
import { Notice, PageHeader } from '@wodi/ui';
import type { ReactNode } from 'react';

// Words shared by the operations screens (docs/plans/phase3-operations-modules.md).
// Times are stored UTC and shown in East Africa Time (CLAUDE.md, domain rule 5).

export { dayText, errorText, LoadFailed, plural } from '../staff/format.tsx';

/** `22 Sep 2026 14:05`, East Africa Time. */
export function dateTimeText(iso: string): string {
  return formatEatDateTime(new Date(iso));
}

/** `22 Sep 2026`, the East Africa Time day of an instant. */
export function dateOfText(iso: string): string {
  return formatEatDate(new Date(iso));
}

/** A page this person may not open: the title and one sentence. */
export function NotAllowed({ title, what }: { title: string; what: string }) {
  return (
    <>
      <PageHeader title={title} />
      <Notice tone="info">
        You don&apos;t have permission to {what}. Ask an administrator if you need it.
      </Notice>
    </>
  );
}

/** Shown under a list when the device is offline. */
export function OfflineListNotice({ online }: { online: boolean }): ReactNode {
  if (online) return null;
  return (
    <Notice tone="info">
      You&apos;re offline. This shows what was last loaded; it updates when you&apos;re back online.
    </Notice>
  );
}
